'use strict';

// Class definition
var KTChartsWidget46 = (function () {
  var chart = {
    self: null,
    rendered: false,
  };

  // Private methods
  var initChart = function () {
    var element = document.getElementById('kt_charts_widget_46');

    if (!element) {
      return;
    }

    var negativeColor = element.hasAttribute('data-kt-negative-color')
      ? element.getAttribute('data-kt-negative-color')
      : KTUtil.getCssVariableValue('--bs-gary-500');

    var height = parseInt(KTUtil.css(element, 'height'));
    var labelColor = KTUtil.getCssVariableValue('--bs-gray-500');
    var borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color');

    var baseColor = KTUtil.getCssVariableValue('--bs-gray-800');

    var options = {
      series: [
        {
          name: 'Subscribed',
          data: [
            20, 30, 20, 40, 60, 75, 65, 18, 10, 5, 15, 40, 60, 18, 35, 55, 20,
          ],
        },
        {
          name: 'Unsubscribed',
          data: [
            -20, -15, -5, -20, -30, -15, -10, -8, -5, -5, -10, -25, -15, -5,
            -10, -5, -15,
          ],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar',
        stacked: true,
        height: height,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          //horizontal: false,
          columnWidth: '35%',
          barHeight: '70%',
          borderRadius: [4, 4],
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [
          'Jan 5',
          'Jan 7',
          'Jan 9',
          'Jan 11',
          'Jan 13',
          'Jan 15',
          'Jan 17',
          'Jan 19',
          'Jan 20',
          'Jan 21',
          'Jan 23',
          'Jan 24',
          'Jan 25',
          'Jan 26',
          'Jan 24',
          'Jan 28',
          'Jan 29',
        ],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tickAmount: 10,
        labels: {
          //rotate: -45,
          //rotateAlways: true,
          style: {
            colors: [labelColor],
            fontSize: '12px',
          },
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        min: -100,
        max: 150,
        tickAmount: 5,
        labels: {
          style: {
            colors: [labelColor],
            fontSize: '12px',
          },
          formatter: function (val) {
            return parseInt(val);
          },
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
          borderRadius: 4,
        },
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + 'K';
            } else {
              return Math.abs(val) + 'K';
            }
          },
        },
      },
      colors: [baseColor, negativeColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    };

    chart.self = new ApexCharts(element, options);

    // Set timeout to properly get the parent elements width
    setTimeout(function () {
      chart.self.render();
      chart.rendered = true;
    }, 200);
  };

  // Public methods
  return {
    init: function () {
      initChart();

      // Update chart on theme mode change
      KTThemeMode.on('kt.thememode.change', function () {
        if (chart.rendered) {
          chart.self.destroy();
        }

        initChart(chart);
      });
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTChartsWidget46;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget46.init();
});
